// extracted by mini-css-extract-plugin
export var card = "cardWithImage-module--card--a6b3b";
export var description = "cardWithImage-module--description--c70d1";
export var title = "cardWithImage-module--title--59b6c";